module.exports = __webpack_public_path__ + "static/media/icsa-crest.1388a352.svg";